import styled from "styled-components";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Colors } from "../../constants/Colors";

export const ContactContainer = styled.div`
  display: flex;
  width: ${(props) => (props.desktop ? props.width : "100%")};
  font-family: "neue-haas-grotesk-text";
  flex-direction: ${(props) => (props.desktop ? "row" : "column")};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop} !important` : "0px !important")};
`;

export const LabelContainer = styled.div`
  margin: 0 0 8px 0;
  font-family: neue-haas-grotesk-text;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  text-align: left;
`;
export const LabelValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  & label {
    font-weight: 700;
  }
  &span .info {
    font-weight: normal;
  }
`;

export const ItemContainer = styled.div`
  width: ${(props) => (props.desktop ? "50%" : "100%")};
  display: flex;
  flex-direction: column;
  font-weight: 700;
  font-size: 12px;
`;

const getInputBorderColor = (props) => {
  if (props.required || props.errorBorder || props.errorBorderOnError) {
    return `${Colors.error} !important`;
  } else if (props.validGreen) {
    return `${Colors.validInput} !important`;
  } else {
    return `${Colors.grayBorder} !important`;
  }
};

export const CustomisedPrimeInput = styled(InputText)`
  font-family: "neue-haas-grotesk-text" !important;
  color: ${Colors.black};
  width: 100%;
  font-size: 14px;
  padding: 12px 16px 12px 16px;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${(props) => getInputBorderColor(props)};
  :hover {
    border: 1px solid ${(props) => (props.required ? `${Colors.error} !important` : `${Colors.activeDefault} !important`)};
  }
  :enabled {
    :focus {
      border: 1px solid
        ${(props) => {
          let borderColor;
          if (props.required) {
            borderColor = `${Colors.error} !important`;
          } else if (props.validGreen) {
            borderColor = `${Colors.validInput} !important`;
          } else {
            borderColor = `${Colors.activeDefault} !important`;
          }
          return borderColor;
        }};
      box-shadow: unset;
    }
  }
  :disabled {
    background: ${Colors.foregroundSecondarybackground};
  }
`;
export const StarSpan = styled.span`
  color: ${(props) => (props.disabled ? Colors.disabledText : Colors.activeDefault)};
  padding: 0 0 0 4px;
  font-size: 15px;
`;

export const ErrorContainer = styled.div`
  margin: 4px 0 0 0;
  font-family: neue-haas-grotesk-text;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${Colors.error};
  letter-spacing: 0;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.desktop ? "row" : "column")};
  gap: ${(props) => (props.desktop ? "16px" : "32px")};
`;

export const CustomizedCountrySelect = styled(Dropdown)`
  height: 42px;
  width: ${(props) => (props.customWidth ? "74px" : "30%")};
  font-size: 14px;
  font-family: "neue-haas-grotesk-text";
  color: ${Colors.black};
  box-sizing: border-box;
  border: 1px solid ${Colors.grayBorder} !important;
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "4px 0 0 4px")};
  &:disabled {
    background: ${Colors.foregroundSecondarybackground};
  }
  &:focus {
    outline: none;
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
  }
  &:hover {
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
    border-radius: ${(props) => {
      if (props.disabled) {
        return "";
      }
      if (props.borderRadius) {
        return props.borderRadius;
      }
      return "4px";
    }};
  }
  &::placeholder {
    color: ${Colors.black};
    font-size: 0.875rem;
  }
  .p-dropdown-trigger {
    width: 25px !important;
  }
  .p-dropdown-label {
    font-size: 14px;
    font-family: "neue-haas-grotesk-text";
    color: ${Colors.black};
    padding: 10px 0px 0px 5px;
  }
`;

// Helper function to determine border style for phone input
const getPhoneInputBorder = (props) => {
  if (props.phoneNumberDefault) {
    return `1px solid ${Colors.grayBorder} !important`;
  } else if (props.validPhoneNumber) {
    return `1px solid ${Colors.validInput} !important`;
  } else {
    return `1px solid ${Colors.error} !important`;
  }
};

const getPhoneInputFocusBorder = (props) => {
  if (props.disabled) {
    return "";
  } else if (props.phoneNumberDefault) {
    return `1px solid ${Colors.activeDefault} !important`;
  } else if (props.validPhoneNumber) {
    return `1px solid ${Colors.validInput} !important`;
  } else {
    return `1px solid ${Colors.error} !important`;
  }
};

export const CustomisedPhoneInput = styled(InputText)`
  box-sizing: border-box;
  border: ${(props) => getPhoneInputBorder(props)};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "0 4px 4px 0")};
  font-size: 14px;
  font-family: "neue-haas-grotesk-text";
  color: ${Colors.black};
  width: ${(props) => (props.customWidth ? "281px" : "70%")};
  height: 42px;
  padding-left: 7px;
  &:disabled {
    background: ${Colors.foregroundSecondarybackground};
    opacity: 0.6;
  }
  :enabled {
    :focus {
      box-shadow: unset;
    }
  }
  &:focus {
    outline: none;
    border: ${(props) => getPhoneInputFocusBorder(props)};
  }
  &:hover:not(:focus) {
    border: ${(props) => (props.disabled ? "" : `1px solid ${Colors.activeDefault} !important`)};
    border-radius: ${(props) => {
      if (props.disabled) {
        return "";
      }
      if (props.borderRadius) {
        return props.borderRadius;
      }
      return "4px";
    }};
  }
  &::placeholder {
    color: ${Colors.foregroundSecondaryText};
    font-size: 14px;
    font-family: "neue-haas-grotesk-text";
    font-weight: 400;
    line-height: 20px;
  }
`;

export const PhoneContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CustomInput = styled(CustomisedPrimeInput)`
  border: ${(props) => props.disabled && `1px solid #e0e0e0 !important`};
  background-color: ${(props) => props.disabled && `#f2f2f2 !important`};
  color: ${(props) => props.disabled && `#747474 !important`};
`;
